import { OrderPaymentStatus, OrderStatus, OrderTransactionStatus } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { ORDER_PAYMENT_STATUS_OPTIONS, ORDER_STATUS_OPTIONS, ORDER_TRANSACTION_STATUS_OPTIONS } from 'noddi-util';
import { ORDER_PAYMENT_STATUS_ICON, ORDER_STATUS_ICON } from '../../../features/Orders/OrderStatusIcon';

/** Order statuses, with their status icons. */
export const ORDER_STATUS_FILTER_OPTIONS: FilterOption<OrderStatus>[] = ORDER_STATUS_OPTIONS.map((option) => ({
  ...option,
  icon: ORDER_STATUS_ICON[option.value]
}));

/** Payment transaction statuses. */
export const ORDER_TRANSACTION_STATUS_FILTER_OPTIONS: FilterOption<OrderTransactionStatus>[] =
  ORDER_TRANSACTION_STATUS_OPTIONS.map(({ value, label }) => ({ value, label }));

/** Order payment statuses, with their status icons. */
export const ORDER_PAYMENT_STATUS_FILTER_OPTIONS: FilterOption<OrderPaymentStatus>[] = ORDER_PAYMENT_STATUS_OPTIONS.map(
  (option) => ({ ...option, icon: ORDER_PAYMENT_STATUS_ICON[option.value] })
);
